import React, { useState, useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';

const EndpointsOverview = () => {
    const [data, setData] = useState({
        totalEndpoints: 0,
        sandboxEndpoints: 0,
        productionEndpoints: 0,
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const apiClient = new APIClient();
            const response: any = await apiClient.get('/dashboard/endpoints-overview');
            if (response?.data) {
                setData({
                    totalEndpoints: response.data.totalEndpoints ?? 0,
                    sandboxEndpoints: response.data.sandboxEndpoints ?? 0,
                    productionEndpoints: response.data.productionEndpoints ?? 0,
                });
            }
        } catch (error) {
            console.error('Error fetching endpoints overview:', error);
        } finally {
            setLoading(false);
        }
    };

    const val = (v: number) => (loading ? '...' : v);

    return (
        <Card className="card-animate h-100">
            <CardBody>
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Endpoints</p>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="avatar-sm rounded">
                            <div className="avatar-title bg-info-subtle text-info fs-20 rounded">
                                <i className="ri-links-line"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column gap-3 mt-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted fs-13">🟠 Sandbox</span>
                        <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                            {val(data.sandboxEndpoints)}
                        </h4>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted fs-13">🟢 Production</span>
                        <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                            {val(data.productionEndpoints)}
                        </h4>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default EndpointsOverview;
